import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./account-contacts.html';
import controller from './AccountContacts';
import styles from './AccountContacts-hashed.scss';

/**
 * @ngdoc component
 * @name edge.gateway.contacts.common.app.component: gwContactsSummaryTable
 *
 * @description  A component to display the contacts in an account.
 *
 * @param accountNumber {string} the account number for the account
 * @param pageSize: {number} the page size used for pagination.
 * @param detailState {string} the target state to be transitioned to when the user selects a contact in the list.
 */
export default {
    controller,
    template: cssUtil.hashTemplate(template, styles),
    bindings: {
        accountNumber: '<',
        pageSize: '<',
        detailState: '@'
    }
};